import './MainActionButton.scss';

/**
 * MainActionButton component for rendering a button with an optional icon, image, title, and subtitle.
 * 
 * @param {Object} props - Component props
 * @param {import('react').ReactNode | string} [props.icon] - Optional icon to display in the button
 * @param {string} [props.image] - Optional image source to display in the button
 * @param {import('react').ReactNode | string} [props.title] - Title text to display on the button
 * @param {string} [props.subTitle] - Optional subtitle text to display below the title
 * @param {React.MouseEventHandler<HTMLDivElement>} [props.onClick] - Function to call when the button is clicked
 * @param {boolean} [props.fullHeight] - If true, applies full height styling to the button
 * @param {string} [props.titlePosition] - CSS class for title positioning
 * @param {Object} [props.imageStyle] - Optional inline styles for the image
 * @param {Object} [props.buttonStyle] - Optional inline styles for the button
 * @param {boolean} [props.disabled] - If true, disables the button and prevents onClick events
 * @returns {JSX.Element} Rendered MainActionButton component
 */
export const MainActionButton = ({
    icon, 
    image, 
    title, 
    subTitle, 
    onClick, 
    fullHeight, 
    titlePosition,
    imageStyle,
    buttonStyle,
    disabled
}) => {

    const handleClick = (e) => {
        if (disabled) return;
        if (onClick) onClick(e);
    };

    return <div 
        className={`MainActionButton ${fullHeight ? 'fullHeight' : ''} ${disabled ? 'disabled' : ''}`}
        style={buttonStyle}
    >
        <div className="clickable" onClick={handleClick}>
            <div className="flout-icon">
                {image ? <img src={image} alt="" style={imageStyle} /> : icon}
            </div>
            <div className="rectangle">
                <div className={`title ${titlePosition}`}>{title}</div>
                <div className="sub-title">{subTitle}</div>
            </div>
        </div>
    </div>
}